module.exports = __webpack_public_path__ + "static/media/pay_refund.ca53dfd0.svg";